import { useParams } from "react-router-dom"
import { getCameraInfo } from "../../api/camsApi"
import { useEffect, useState } from "react"
import { useDispatch } from "react-redux"
import { setRoadWebCameraInfo } from "../../stateManagement/reducers/RoadWebCameraSlice"

export default function RoadWebCameraViewer() {
    const dispatch = useDispatch()
    const { roadWebCameraId }: any = useParams()
    const [cameraSrc, setCameraSrc] = useState<any>()


    async function initializeCamera() {
        const cameraInfo = await getCameraInfo(roadWebCameraId)
        const cameraId = cameraInfo?.id
        const newCameraSrc = `https://www.youtube.com/embed/${cameraId}?autoplay=1`
        setCameraSrc(newCameraSrc)
        dispatch(setRoadWebCameraInfo(cameraInfo))
    }

    useEffect(() => {
        initializeCamera()
    }, [])

    return (
        <div className="road-web-camera-viewer-div">
            <iframe
                width="100%"
                height="100%"
                src={cameraSrc}
                title={`camera-${roadWebCameraId}`}
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share; fullscreen;>">
            </iframe>
        </div >
    )
}
